import { AddressType } from "@redotech/redo-model/address-collection";
import { AddressSchema } from "@redotech/redo-model/team";
import * as z from "zod/v4";

export const createAddress = {
  name: "createAddress" as const,
  input: z.object({ type: z.enum(AddressType), address: AddressSchema }),
  output: z.object({ addressId: z.string() }),
};
